import { render, staticRenderFns } from "./edit.lists.page.vue?vue&type=template&id=15282786&"
import script from "./edit.lists.page.vue?vue&type=script&lang=js&"
export * from "./edit.lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports